// extracted by mini-css-extract-plugin
module.exports = {"switch":"_9e1425b4d3--switch--He7wp","indicator":"_9e1425b4d3--indicator--jttd7","label":"_9e1425b4d3--label--eS7WL"};